<template>

  <div class="noresults">
    <h5><slot></slot></h5>
  </div>

</template>

<script>
export default {
  name: 'NoResults',
  components: {
  },
  props: [
  ],
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .noresults{
    padding: 0;
    color: rgba(0,0,0,0.6);
  }
  .noresults h5{
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Parts/NoResults.vue